/* eslint-disable */
/* tslint:disable */
/* Do not edit - generated by swagger-typescript-api */

import {
  ConfigurationFieldSpecificationResponseCollectionResponse,
  ErrorResponse,
} from './data-contracts';
import { HttpClient, RequestParams } from './http-client';
export class ConfigurationFieldSpecifications<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>;
  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http;
  }
  /**
   * No description
   *
   * @tags ConfigurationFieldSpecifications
   * @name GetConfigurationFieldSpecifications
   * @request GET:/ConfigurationFieldSpecifications
   * @response `200` `ConfigurationFieldSpecificationResponseCollectionResponse` OK
   * @response `400` `ErrorResponse` The request was refused. Messages carries the text, Problems the structured rules that refused it.
   */
  getConfigurationFieldSpecifications = (params: RequestParams = {}) =>
    this.http.request<ConfigurationFieldSpecificationResponseCollectionResponse, ErrorResponse>({
      path: `/ConfigurationFieldSpecifications`,
      method: 'GET',
      format: 'json',
      ...params,
    });
}
